import { ObjectParams, ObjectsParams } from '../../types/ParamsTypes';
import { ObjectAdvertisingData } from '../../types/ObjectTypes';

export const getPriceAdText = (
  numberOfDays: number,
  numberOfPersons: number,
  objectsParams: ObjectParams | ObjectsParams,
): string => {
  const numberOfDaysText = `bei ${numberOfDays} ${numberOfDays > 1 ? 'Nächte' : 'Nacht'}`;
  const numberOfPersonsText = `${numberOfPersons} ${numberOfPersons > 1 ? 'Personen' : 'Person'}`;
  const numberOfPetsText =
    objectsParams.numberOfPets &&
    `${objectsParams.numberOfPets} ${objectsParams.numberOfPets > 1 ? 'Haustiere' : 'Haustier'}`;
  const endText = numberOfPetsText ? `, ${numberOfPetsText}` : '';
  return `${numberOfDaysText}, ${numberOfPersonsText}${endText}`;
};

export const getPriceDetailsText = (
  numberOfDays: any,
  objectsParams: ObjectParams | ObjectsParams,
): string => {
  const numberOfDaysText = `bei ${numberOfDays} ${numberOfDays > 1 ? 'Nächte' : 'Nacht'}`;
  const numberOfPersons = objectsParams.numberOfAdults + objectsParams.numberOfChildren;
  const numberOfPersonsText = `${numberOfPersons} ${numberOfPersons > 1 ? 'Personen' : 'Person'}`;
  const numberOfPetsText =
    objectsParams.numberOfPets &&
    `${objectsParams.numberOfPets} ${objectsParams.numberOfPets > 1 ? 'Haustiere' : 'Haustier'}`;
  const endText = numberOfPetsText ? `, ${numberOfPetsText}` : '';
  return `${numberOfDaysText}, ${numberOfPersonsText}${endText}`;
};
